import { render, staticRenderFns } from "./VaStateBadge.vue?vue&type=template&id=d202a522&scoped=true&"
import script from "./VaStateBadge.vue?vue&type=script&lang=ts&"
export * from "./VaStateBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d202a522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d202a522')) {
      api.createRecord('d202a522', component.options)
    } else {
      api.reload('d202a522', component.options)
    }
    module.hot.accept("./VaStateBadge.vue?vue&type=template&id=d202a522&scoped=true&", function () {
      api.rerender('d202a522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/VaStateBadge.vue"
export default component.exports